import CommonTable from "@/components/commonTable";
import { calibrateYuanzhiyunCameraRequest } from "@/service/calibrate";
import { useTable } from "@/utils/useTable";
import { useMemo } from "react";
import { renderYuanzhiyunCalibrationStatus } from "./status";

interface CalibrateTableYuanzhiyunCameraProps {
    diagnosisSearchParams: any;
    carId?: number
}


const CalibrateTableYuanzhiyunCamera = (props: CalibrateTableYuanzhiyunCameraProps) => {
    const { diagnosisSearchParams = {}, carId } = props;

    const searchParams = useMemo(() => {
        const _params = {
            ...diagnosisSearchParams
        }
        if (carId) {
            _params.carId = carId;
        }
        return _params;
    }, [diagnosisSearchParams, carId]);

    const { page, limit, loading, data, totalCount, onPageChange } = useTable({
        requestFunc: calibrateYuanzhiyunCameraRequest,
        initRequest: true,
        initPageSize: 40,
        searchParams
    });

    const columns = [
        {
            title: '上报时间',
            dataIndex: 'reportTime'
        },
        {
            title: '参数版本号',
            dataIndex: 'version'
        },
        {
            title: '标定状态',
            dataIndex: 'success',
            render: renderYuanzhiyunCalibrationStatus
        },
        {
            title: '车宽(前轮胎外边缘距离)(单位:毫米)',
            dataIndex: 'frontTireWidth'
        },
        {
            title: '后轴到前保的距离(单位:毫米)',
            dataIndex: 'rearAxleToFrontBumper'
        },
        {
            title: '轴距(单位:毫米)',
            dataIndex: 'wheelbase'
        },
        {
            title: '摄像头到前保的纵向距离(负值)(单位:米)',
            dataIndex: 'cameraFrontBumperDistance'
        },
        {
            title: '摄像头中线距离(左正右负)(单位:米)',
            dataIndex: 'cameraCenterOffset'
        },
        {
            title: '摄像头到地面距离(单位:米)',
            dataIndex: 'cameraHeight'
        },
        {
            title: '摄像头相对横向偏差(左正右负)(单位:毫米)',
            dataIndex: 'cameraLateralDeviation'
        },
        {
            title: '标定板图案中心高度(单位:米)',
            dataIndex: 'calibrationBoardCenterHeight'
        },
        {
            title: '标定后位置x',
            dataIndex: 'locationX'
        },
        {
            title: '标定后位置y',
            dataIndex: 'locationY'
        },
        {
            title: '标定后位置z',
            dataIndex: 'locationZ'
        },
        {
            title: '标定后pitch',
            dataIndex: 'pitch'
        },
        {
            title: '标定后yaw',
            dataIndex: 'yaw'
        },
        {
            title: '标定后roll',
            dataIndex: 'roll'
        },
    ];

    return (
        <CommonTable
            rowKey="id"
            columns={columns}
            dataSource={data}
            pagination={{
                total: totalCount,
                current: page,
                pageSize: limit,
                onChange: onPageChange
            }}
            bordered
            loading={loading}
            scroll={{ x: '100%', y: 400 }}
        />
    );
};

export default CalibrateTableYuanzhiyunCamera;
